import { render } from "./Documentation.vue?vue&type=template&id=8573bb9e&scoped=true"
const script = {}

import "./Documentation.vue?vue&type=style&index=0&id=8573bb9e&scoped=true&lang=scss"

import exportComponent from "/opt/render/project/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8573bb9e"]])

export default __exports__